// Home shortcuts use native React clicks; never synthesize a second navigation.
const TARGETS = ".pwa-personal-save, .pwa-family-save";

/**
 * iOS Safari can swallow the synthesized click for dynamically inserted buttons
 * inside long, scrollable app surfaces, including settings sheets and Home cards.
 * Keep the normal click handlers as the source of truth, but translate a clean
 * touch release into a programmatic click when Safari does not deliver one.
 */
export function installPwaIosButtonFix() {
  let lastNativeClickAt = 0;

  document.addEventListener("click", (event) => {
    const target = (event.target as HTMLElement | null)?.closest<HTMLButtonElement>(TARGETS);
    if (target) lastNativeClickAt = Date.now();
  }, true);

  document.addEventListener("touchend", (event) => {
    const target = (event.target as HTMLElement | null)?.closest<HTMLButtonElement>(TARGETS);
    if (!target || target.disabled) return;

    // Give Safari's normal synthesized click a moment to fire first.
    const touchEndedAt = Date.now();
    window.setTimeout(() => {
      if (!document.contains(target) || target.disabled) return;
      if (lastNativeClickAt >= touchEndedAt) return;
      target.click();
    }, 80);
  }, { capture: true, passive: true });

  const style = document.createElement("style");
  style.textContent = `${TARGETS}{touch-action:manipulation;-webkit-tap-highlight-color:rgba(0,0,0,.08);position:relative;z-index:2;pointer-events:auto!important;cursor:pointer}`;
  document.head.appendChild(style);
}

